import { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import OptimizedImage from "@/components/OptimizedImage";
import BookLookInsideModal from "@/components/BookLookInsideModal";
import Reveal from "@/components/Reveal";

export default function CareerWealthPage() {
  const [lookInsideOpen, setLookInsideOpen] = useState(false);
  return (
    <Layout>
      {/* Hero */}
      <header className="hero">
        <div className="container hero-grid">
          <div>
            <div className="hero-kicker">CAREER &amp; FINANCIAL TRANSFORMATION</div>
            <h1 className="hero-title">
              RICH BY THIRTY, <br />
              <span className="text-gold">BROKE BY THIRTY.</span>
            </h1>
            <p className="hero-subtitle">
              Build Wealth, Escape the Debt Trap, and Secure Your Financial Future from Your Very First Paycheck.
            </p>
            <div className="hero-actions">
              <Link to="/checkout?product=rich-by-thirty" className="btn btn-primary-gold btn-lg">
                GET THE BOOK ($14.99) →
              </Link>
              <a href="#framework" className="btn btn-outline btn-lg">
                EXPLORE THE 4-PART FRAMEWORK
              </a>
            </div>
            <div className="hero-trust">
              <span className="hero-trust__chip"><strong>25</strong> chapters</span>
              <span className="hero-trust__chip"><strong>4-part</strong> framework</span>
              <span className="hero-trust__chip">Instant digital download</span>
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div className="hero-banner-wrap" style={{ maxWidth: "320px" }}>
              <OptimizedImage src="/assets/books/rich-by-thirty.png" alt="Rich by Thirty, Broke by Thirty" className="hero-banner-img" width={320} height={480} priority />
            </div>
          </div>
        </div>
      </header>

      {/* Audience */}
      <Reveal as="section" className="container section-padding">
        <div style={{ background: "var(--navy-card)", border: "1px solid var(--border-gold)", borderRadius: "var(--radius-xl)", padding: "44px", maxWidth: "880px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "28px" }}>
            <div className="hero-kicker">QUALIFICATION</div>
            <h2 style={{ fontSize: "2.4rem" }}>WHO THIS BOOK IS FOR</h2>
          </div>
          <div className="for-you-box" style={{ padding: "24px" }}>
            <ul className="for-you-list" style={{ fontSize: "1rem", lineHeight: 1.8 }}>
              <li>Salaried professionals earning their first paycheck or experiencing career growth.</li>
              <li>Anyone who feels their income is increasing, but their net worth is staying flat.</li>
              <li>People who want to avoid high-interest lifestyle inflation, EMI traps, and social pressure spending.</li>
              <li>Young adults looking for a simple, repeatable blueprint for financial independence.</li>
            </ul>
          </div>
        </div>
      </Reveal>

      {/* Framework — "Look inside" opens the full TOC modal */}
      <Reveal as="section" id="framework" className="container section-padding" style={{ borderTop: "1px solid var(--border-glass)" }}>
        <div style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto 28px auto" }}>
          <div className="hero-kicker">MANUSCRIPT ARCHITECTURE</div>
          <h2 style={{ fontSize: "2.8rem" }}>THE FOUR-PART FINANCIAL FRAMEWORK</h2>
          <p style={{ color: "var(--text-secondary)", fontSize: "1.05rem", marginTop: "8px" }}>
            All 25 chapters from the manuscript, in four parts, designed to guide you from the trap to escape velocity.
          </p>
        </div>

        <div style={{ maxWidth: "320px", margin: "0 auto", textAlign: "center" }}>
          <button type="button" className="look-inside-btn" onClick={() => setLookInsideOpen(true)}>
            <span aria-hidden="true">👁</span> Look inside
          </button>
        </div>
      </Reveal>

      {/* Disclaimer */}
      <Reveal as="section" className="container" style={{ paddingBottom: "60px" }}>
        <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid var(--border-glass)", borderRadius: "var(--radius-md)", padding: "16px 20px", fontSize: "0.825rem", color: "var(--text-muted)", lineHeight: 1.6, maxWidth: "900px", margin: "0 auto" }}>
          <strong>Educational Disclaimer:</strong> Rich by Thirty, Broke by Thirty is designed for educational and informational purposes only. It does not constitute formal financial, investment, legal, or tax advice. Readers should evaluate their personal financial circumstances or consult a qualified professional before making investment decisions.
        </div>
      </Reveal>

      {/* CTA */}
      <Reveal as="section" className="container section-padding" style={{ textAlign: "center", maxWidth: "800px" }}>
        <h2 style={{ fontSize: "2.8rem", marginBottom: "16px" }}>
          YOUR SALARY CAN EITHER BUILD A TRAP <br />
          <span className="text-gold">OR BUILD YOUR FREEDOM.</span>
        </h2>
        <p style={{ fontSize: "1.1rem", color: "var(--text-secondary)", marginBottom: "32px" }}>
          Get instant digital access to Rich by Thirty, Broke by Thirty ($14.99)
        </p>
        <Link to="/checkout?product=rich-by-thirty" className="btn btn-primary-gold btn-lg">
          GET THE BOOK ($14.99) →
        </Link>
      </Reveal>

      {/* "Look inside" modal — full manuscript TOC */}
      {lookInsideOpen ? (
        <BookLookInsideModal bookId="rich-by-thirty" onClose={() => setLookInsideOpen(false)} />
      ) : null}
    </Layout>
  );
}

